<template>
	<div id="text-page">
		<div class="container">
			<h1 class="mb-2 page-title"> {{ 'terminos-y-condiciones' | static-title }}</h1>
			<static-markdown :content="'terminos-y-condiciones' | static-content"></static-markdown>
		</div>
	</div>
</template>

<script>
export default {}
</script>
